import { Component, input } from '@angular/core';
import { NgIcon, provideIcons } from '@ng-icons/core';
import { tablerLock, tablerExternalLink } from '@ng-icons/tabler-icons';
import { PrimaryBtnDirective } from './primary-button';
import { RequestAccess } from './request-access/request-access';

@Component({
  selector: 'asset-launch-button',
  template: `
    @if (hasAccess()) {
      @if (isIconButton()) {
        <button class="icon-button" (click)="ctaAction($event)" title="Launch" target="_blank">
          <ng-icon size="14px" name="tablerExternalLink" />
        </button>
      } @else {
        <button appPrimaryBtn class="full-button" (click)="ctaAction($event)">
          <ng-icon size="18px" name="tablerExternalLink" />
          Launch
        </button>
      }
    } @else {
      <request-access
        [assetId]="assetId()"
        [assetName]="assetName()"
        [isIconButton]="isIconButton()"
        [ownerName]="ownerName()"
        [ownerEmail]="ownerEmail()"
      />
    }
  `,
  styles: `
    .icon-button {
      width: 28px;
      height: 28px;
      border: none;
      background: none;
      cursor: pointer;
      border-radius: 6px;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #007db7;
      transition:
        background 0.15s,
        color 0.15s;

      &:hover {
        background: rgba(0, 125, 183, 0.1);
      }

      &:disabled {
        opacity: 0.4;
        cursor: not-allowed;
        pointer-events: none;
      }
    }

    .full-button {
      min-width: 120px;
    }
  `,
  imports: [NgIcon, PrimaryBtnDirective, RequestAccess],
  providers: [provideIcons({ tablerLock, tablerExternalLink })],
})
export class AssetLaunchButton {
  productLink = input.required<string>();
  isIconButton = input(false);
  assetName = input.required<string>();
  assetId = input.required<string>();
  hasAccess = input.required<boolean>();
  readonly ownerName = input.required<string | null>();
  readonly ownerEmail = input.required<string | null>();

  ctaAction = (e: Event): void => {
    e.stopPropagation();
    if (this.hasAccess() && this.productLink()) {
      window.open(this.productLink(), '_blank');
    }
  };
}
